export default "/images/framework/MyRankingCht.3a5e810a.svg?3a5e810a";